import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { of } from 'rxjs';

import type { BillingInformation } from '@core/billing-information-types';

@Injectable({ providedIn: 'root' })
export class BillingInformationService {
  public validate(billingInformation: Partial<BillingInformation>): Observable<boolean> {
    const requiredFields: Array<keyof BillingInformation> = [
      'address',
      'city',
      'companyName',
      'countryCode',
      'email',
      'postalCode',
    ];

    return of(
      requiredFields
        .map(k => billingInformation[k])
        .every(val => val !== undefined && val !== null && val !== ''),
    );
  }
}
